import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';


export const moduleRoleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const allowedRoles = route.data['allowedRoles'] as number[] | undefined;

  if (!allowedRoles?.length) {
    router.navigateByUrl('/');
    return false;
  }
  if (authService.hasRole(allowedRoles)) return true;

  router.navigateByUrl('/');
  return false;
};
